{
  "academic-title-type.menu.title": "Typy titulov",

  "academic-title.menu.title": "Tituly",

  "activity.columns.author.label": "Autor",
  "activity.columns.event-type.label": "Typ aktivity",
  "activity.columns.message.label": "Podrobnosti",
  "activity.columns.root-id.label": "ID koreňovej agendy",
  "activity.columns.root-type.label": "Koreňová agenda",
  "activity.columns.timestamp.label": "Dátum a čas",
  "activity.menu.title": "Aktivity",
  "activity.title": "Aktivity",

  "address-type.menu.title": "Typ adresy",

  "administration.menu.title": "Administrácia",
  "administration.notification.menu.title": "Notifikácie",

  "app.sidebar.settings": "Profil a nastavenia",
  "app.sidebar.user": "Používateľ",

  "calendar.deadline.detail.action": "Detail lehoty",
  "calendar.deadline.detail.deadline": "Lehota",
  "calendar.deadline.detail.end": "Koniec",
  "calendar.deadline.detail.name": "Názov",
  "calendar.deadline.detail.start": "Začiatok",
  "calendar.filter.no-value": "Žiadna hodnota",
  "calendar.filter.reset": "Resetovať",
  "calendar.filters.close": "Zavrieť",
  "calendar.filters.deadline": "Lehota",
  "calendar.filters.deadline-proceeding": "Správne konanie",
  "calendar.filters.deadlines": "Lehoty",
  "calendar.filters.end": "Koniec",
  "calendar.filters.open": "Filtre",
  "calendar.filters.reminder": "Pripomenutie pred koncom",
  "calendar.filters.reset": "Resetovať filtre",
  "calendar.filters.start": "Začiatok",
  "calendar.filters.task-description": "Popis",
  "calendar.filters.task-type": "Typ",
  "calendar.filters.tasks": "Úlohy",
  "calendar.filters.title": "Filtre kalendára",
  "calendar.menu.label": "Kalendár",
  "calendar.task.complete.cancel": "Zrušiť",
  "calendar.task.complete.confirm-button": "Potvrdiť",
  "calendar.task.detail.action": "Detail úlohy",
  "calendar.task.detail.assignees": "Riešitelia",
  "calendar.task.detail.created-at": "Vytvorené",
  "calendar.task.detail.description": "Popis",
  "calendar.task.detail.task": "Úloha",
  "calendar.task.detail.type": "Typ úlohy",

  "certificate.menu.title": "Certifikáty",

  "common.web.title": "Úrad pre dohľad nad zdravotnou starostlivosťou",

  "console.menu.title": "Konzola",

  "country.menu.title": "Štáty",

  "county.menu.title": "Okresy",

  "data-table.create": "Pridať nový záznam",
  "data-table.filter.date-from.label": "Od",
  "data-table.filter.date-to.label": "Do",
  "data-table.filter.placeholder": "Pridať hodnotu",

  "deadline.actions.mock-create-proceeding-deadline.button.text": "Testovacia lehota",
  "deadline.actions.mock-create-proceeding-deadline.confirm.content": "Chcete vytvoriť testovaciu lehotu pre konanie?",
  "deadline.actions.mock-create-proceeding-deadline.title": "Vytvoriť testovaciu lehotu",
  "deadline.actions.mock-create-proceeding-deadline.toast.success": "Testovacia lehota bola úspešne vytvorená.",
  "deadline.columns.duration.label": "Doba trvania",
  "deadline.columns.lapse-type.label": "Typ plynutia lehoty",
  "deadline.evidence.table.title": "Lehoty",
  "deadline.fields.duration.label": "Doba trvania",
  "deadline.fields.lapse-type.label": "Typ plynutia lehoty",
  "deadline.fields.manual.label": "Manuálne splnenie lehoty",
  "deadline.fields.notification-duration-before-end-date.label": "Počet pracovných dní pred koncom na odoslanie notifikácie",
  "deadline.instance.base-info.layout-group.deadline.title": "Definícia lehoty",
  "deadline.instance.base-info.layout-group.instance.title": "Lehota",
  "deadline.instance.base-info.layout-group.proceeding.title": "Správne konanie",
  "deadline.instance.buttons.open-proceeding.text": "Detail",
  "deadline.instance.columns.completion-date.label": "Dátum splnenia",
  "deadline.instance.columns.deadline.label": "Lehota",
  "deadline.instance.columns.end.label": "Koniec",
  "deadline.instance.columns.notification-duration-before-end-date.label": "Pripomenutie pred koncom",
  "deadline.instance.columns.proceeding.label": "Správne konanie",
  "deadline.instance.columns.start.label": "Začiatok",
  "deadline.instance.columns.state.label": "Stav",
  "deadline.instance.complete.button": "Splniť lehotu",
  "deadline.instance.complete.close": "Zavrieť",
  "deadline.instance.complete.confirm": "Naozaj chcete označiť lehotu ako splnenú?",
  "deadline.instance.complete.confirm-button": "Potvrdiť",
  "deadline.instance.complete.success": "Lehota bola označená ako splnená.",
  "deadline.instance.complete.title": "Splniť lehotu",
  "deadline.instance.evidence.table.title": "Lehoty",
  "deadline.instance.fields.completion-date.label": "Dátum splnenia",
  "deadline.instance.fields.deadline-description.label": "Popis",
  "deadline.instance.fields.deadline-title.label": "Názov",
  "deadline.instance.fields.duration.label": "Doba trvania",
  "deadline.instance.fields.end.label": "Koniec",
  "deadline.instance.fields.lapse-type.label": "Typ plynutia lehoty",
  "deadline.instance.fields.notification-duration-before-end-date.label": "Počet pracovných dní pred koncom na odoslanie notifikácie",
  "deadline.instance.fields.proceeding-label.label": "Názov",
  "deadline.instance.fields.start.label": "Začiatok",
  "deadline.instance.fields.state.label": "Stav",
  "deadline.instance.fields.suspended-from.label": "Pozastavené od",
  "deadline.instance.fields.suspended-to.label": "Pozastavené do",
  "deadline.instance.menu.label": "Lehoty",
  "deadline.instance.state.option.active": "Aktívna",
  "deadline.instance.state.option.canceled": "Zrušená",
  "deadline.instance.state.option.completed": "Splnená",
  "deadline.instance.state.option.expired": "Ukončená",
  "deadline.instance.state.option.suspended": "Pozastavená",
  "deadline.instance.tabs.base-info": "Základné informácie",
  "deadline.lapse-type.option.calendar-days": "Kalendárne dni",
  "deadline.lapse-type.option.months": "Mesiace",
  "deadline.lapse-type.option.weeks": "Týždne",
  "deadline.lapse-type.option.working-days": "Pracovné dni",
  "deadline.lapse-type.option.years": "Roky",
  "deadline.menu.label": "Lehoty",
  "deadline.tabs.base-info": "Základné informácie",

  "department-type.menu.title": "Typy organizačných útvarov",

  "dictionaries.group.addresses-and-territory": "Adresy a územie",
  "dictionaries.group.electronic-communication": "Elektronická komunikácia",
  "dictionaries.group.personal-data": "Osobné údaje",
  "dictionaries.group.proceeding": "Správne konanie",
  "dictionaries.group.subjects-and-insurance": "Subjekty a poisťovne",
  "dictionaries.group.tasks": "Úlohy",
  "dictionaries.menu.title": "Číselníky",

  "env-managment.menu.title": "Správa prostredia",

  "form-template.type.case": "Správne konanie",

  "forms.form-submission.menu.title": "Vyplnené formuláre",
  "forms.form-template.deadlines.add": "Pridať lehotu",
  "forms.form-template.deadlines.assignment.new-title": "Nová lehota",
  "forms.form-template.deadlines.deadline.label": "Lehota",
  "forms.form-template.deadlines.detail": "Detail lehoty",
  "forms.form-template.deadlines.empty": "Šablóna nemá naviazané žiadne lehoty.",
  "forms.form-template.deadlines.record-state.label": "Stav registratúrneho záznamu",
  "forms.form-template.deadlines.remove": "Odstrániť lehotu",
  "forms.form-template.menu.title": "Šablóny formulárov",
  "forms.form-template.tabs.deadlines.label": "Lehoty",
  "forms.form-template.validation.deadline-assignments.deadline.duplicate": "Lehota je už k šablóne priradená s rovnakým stavom registratúrneho záznamu.",
  "forms.form-template.validation.deadline-assignments.deadline.required": "Lehota je povinná.",
  "forms.menu.title": "Formuláre",

  "gender.menu.title": "Pohlavie",

  "health-insurance.menu.title": "Zdravotné poisťovne",

  "home.plugin.calendar.description": "Zobrazuje kalendár udalostí na nástenke.",
  "home.plugin.calendar.title": "Kalendár",

  "legal-form.menu.title": "Právne formy",

  "municipality-part.menu.title": "Časti obcí",

  "municipality.menu.title": "Obce",

  "notification.admin.menu.title": "Prehľad notifikácií",
  "notification.preferences.menu.label": "Nastavenia notifikácií",
  "notification.sidebar.title": "Upozornenia",
  "notification.template.menu.title": "Notifikačné šablóny",

  "notifications.delete": "Odstrániť",
  "notifications.mark-all-as-read": "Označiť všetky ako prečítané",
  "notifications.mark-as-read": "Označiť ako prečítané",
  "notifications.marked-as-unread": "Označené ako neprečítané",
  "notifications.menu.title": "Notifikácie",
  "notifications.no-notifications": "Žiadne notifikácie",
  "notifications.show-all": "Zobraziť aj prečítané",

  "organizational-unit.detail.fields.alias.label": "Skratka",
  "organizational-unit.detail.fields.code.label": "Kód",
  "organizational-unit.detail.fields.default-proceeding-category.label": "Predvolený druh konania",
  "organizational-unit.detail.fields.department-type-code.label": "Kód typu útvaru",
  "organizational-unit.detail.fields.department-type.label": "Typ útvaru",
  "organizational-unit.detail.fields.description.label": "Popis",
  "organizational-unit.detail.fields.main-code.label": "Hlavný kód",
  "organizational-unit.detail.fields.parent-code.label": "Kód nadriadeného útvaru",
  "organizational-unit.detail.fields.parent.label": "Nadriadený útvar",
  "organizational-unit.detail.fields.title.label": "Názov",
  "organizational-unit.detail.groups.basic-info.title": "Základné údaje",
  "organizational-unit.detail.tabs.basic-info.label": "Základné údaje",
  "organizational-unit.evidence.table.title": "Organizačné útvary",
  "organizational-unit.menu.title": "Organizačné útvary",

  "page-404.text.description": "Ospravedlňujeme sa, ale táto stránka sa nenašla. Skontrolujte, či máte správnu URL adresu.",
  "page-404.text.title": "stránka sa nenašla",

  "page-error.401.description": "Ak chcete zobraziť túto stránku, musíte sa prihlásiť.",
  "page-error.401.title": "prihlásenie je vyžadované",
  "page-error.403.description": "Nemáte dostatočné oprávnenia na zobrazenie tejto stránky.",
  "page-error.403.title": "prístup zamietnutý",
  "page-error.500.description": "Skúste sa znova prihlásiť.",
  "page-error.500.title": "prihlásenie sa nepodarilo dokončiť",
  "page-error.button.home": "Späť na nástenku",

  "planned-jobs.menu.title": "Plánované úlohy",

  "proceeding-batch-import.columns.duplicate-count": "Duplicity",
  "proceeding-batch-import.columns.failed-count": "Chybné",
  "proceeding-batch-import.columns.file": "Súbor",
  "proceeding-batch-import.columns.finished-at": "Ukončené",
  "proceeding-batch-import.columns.imported-count": "Naimportované",
  "proceeding-batch-import.columns.requested-count": "Zaradené záznamy",
  "proceeding-batch-import.columns.status": "Stav",
  "proceeding-batch-import.confirm": "Importovať valídne záznamy",
  "proceeding-batch-import.detail.batch.title": "Dávka",
  "proceeding-batch-import.detail.result.title": "Výsledok spracovania",
  "proceeding-batch-import.dialog.title": "Import dávky",
  "proceeding-batch-import.error.content-storage-failed": "Podklady sa nepodarilo uložiť.",
  "proceeding-batch-import.error.correction-not-supported": "Opravné dávky nie sú podporované.",
  "proceeding-batch-import.error.document-creation-failed": "Dokument správneho konania sa nepodarilo vytvoriť.",
  "proceeding-batch-import.error.header-record-count-mismatch": "Počet záznamov nezodpovedá údaju v hlavičke dávky.",
  "proceeding-batch-import.error.import-record-creation-failed": "Evidenciu importovaného záznamu sa nepodarilo vytvoriť.",
  "proceeding-batch-import.error.invalid-header": "Hlavička dávky nie je platná.",
  "proceeding-batch-import.error.proceeding-creation-failed": "Správne konanie sa nepodarilo vytvoriť.",
  "proceeding-batch-import.error.processing-interrupted": "Spracovanie dávky bolo prerušené. Už vytvorené konania zostali zachované.",
  "proceeding-batch-import.error.pv-record-count-invalid": "PV dávka musí obsahovať práve jeden dátový záznam.",
  "proceeding-batch-import.error.pv-source-count-invalid": "PV ZIP musí obsahovať práve jeden zdrojový súbor.",
  "proceeding-batch-import.error.record-field-count-invalid": "Riadok obsahuje nesprávny počet polí.",
  "proceeding-batch-import.error.record-value-invalid": "Hodnota v riadku nie je platná.",
  "proceeding-batch-import.error.registry-file-creation-failed": "Registratúrny spis sa nepodarilo vytvoriť.",
  "proceeding-batch-import.error.registry-record-creation-failed": "Registratúrny záznam sa nepodarilo vytvoriť.",
  "proceeding-batch-import.error.required-field-missing": "V riadku chýba povinný údaj.",
  "proceeding-batch-import.error.ris-operation-failed": "Operácia v registratúrnom informačnom systéme zlyhala.",
  "proceeding-batch-import.error.subject-creation-failed": "Účastníka sa nepodarilo vytvoriť.",
  "proceeding-batch-import.error.subject-identification-failed": "Stotožnenie účastníka sa nepodarilo dokončiť.",
  "proceeding-batch-import.error.too-many-errors": "Dávku nie je možné importovať, obsahuje {invalid} chybných záznamov z celkového počtu {total} záznamov.",
  "proceeding-batch-import.error.unknown-processing-error": "Pri spracovaní záznamu nastala neočakávaná chyba.",
  "proceeding-batch-import.error.unsupported-batch-type": "Typ dávky nie je podporovaný.",
  "proceeding-batch-import.error.unsupported-file-format": "Formát súboru nie je pre manuálny import podporovaný.",
  "proceeding-batch-import.error.xml-structure-invalid": "XML štruktúra dávky nie je platná.",
  "proceeding-batch-import.error.zip-invalid": "ZIP súbor nie je platný.",
  "proceeding-batch-import.errors.code": "Kód chyby",
  "proceeding-batch-import.errors.line": "Riadok",
  "proceeding-batch-import.errors.reason": "Dôvod",
  "proceeding-batch-import.evidence.title": "Importy dávok",
  "proceeding-batch-import.fields.channel.label": "Kanál",
  "proceeding-batch-import.fields.duplicate-count.label": "Duplicitné záznamy",
  "proceeding-batch-import.fields.error-summary.label": "Chybový súhrn",
  "proceeding-batch-import.fields.failed-count.label": "Chybné záznamy",
  "proceeding-batch-import.fields.file.label": "Súbor",
  "proceeding-batch-import.fields.finished-at.label": "Ukončenie spracovania",
  "proceeding-batch-import.fields.imported-count.label": "Naimportované záznamy",
  "proceeding-batch-import.fields.requested-by.label": "Spustil",
  "proceeding-batch-import.fields.requested-count.label": "Zaradené záznamy",
  "proceeding-batch-import.fields.started-at.label": "Začiatok spracovania",
  "proceeding-batch-import.fields.status.label": "Stav",
  "proceeding-batch-import.preview.another-import-running": "Práve sa spracúva iná dávka. Počet duplicít a počet záznamov, ktoré sa skutočne importujú, sa preto môže pri spracovaní tejto dávky zmeniť.",
  "proceeding-batch-import.preview.duplicate-count.label": "Počet duplicitných záznamov",
  "proceeding-batch-import.preview.duplicate-count.value": "{duplicates}/{total}",
  "proceeding-batch-import.preview.errors.title": "Chybné záznamy",
  "proceeding-batch-import.preview.invalid-count.label": "Počet chybných záznamov",
  "proceeding-batch-import.preview.invalid-count.value": "{invalid}/{total}",
  "proceeding-batch-import.preview.valid-count.label": "Počet valídnych záznamov",
  "proceeding-batch-import.preview.valid-count.value": "{valid}/{total}",
  "proceeding-batch-import.report.download": "Stiahnuť report",
  "proceeding-batch-import.start": "Import dávky",
  "proceeding-batch-import.start.success": "Dávka bola zaradená na spracovanie.",
  "proceeding-batch-import.status.completed": "Dokončené",
  "proceeding-batch-import.status.completed-with-errors": "Dokončené s chybami",
  "proceeding-batch-import.status.failed": "Zlyhalo",
  "proceeding-batch-import.status.queued": "Čaká na spracovanie",
  "proceeding-batch-import.status.running": "Spracúva sa",

  "proceeding.actions.appeal-second-stage.button.text": "Odvolacie konanie II. stupeň",
  "proceeding.actions.appeal-second-stage.text.message": "Chcete presunúť konanie do odvolacieho konania na druhom stupni?",
  "proceeding.actions.appeal-second-stage.title": "Začať odvolacie konanie na druhom stupni",
  "proceeding.actions.appeal-second-stage.toast.success": "Konanie bolo úspešne presunuté do odvolacieho konania na druhom stupni.",
  "proceeding.actions.bulk-generate-documents.error": "Vytvorenie záznamov zlyhalo.",
  "proceeding.actions.bulk-generate-documents.group.title": "Základné informácie",
  "proceeding.actions.bulk-generate-documents.result": "Vytvorené: {succeeded}, neúspešné: {failed}.",
  "proceeding.actions.bulk-generate-documents.title": "Hromadné generovanie záznamov",
  "proceeding.actions.bulk-generate-documents.tooltip": "Hromadné generovanie záznamov",
  "proceeding.actions.cancel.button.text": "Zrušiť",
  "proceeding.actions.cancel.text.message": "Chcete zrušiť konanie?",
  "proceeding.actions.cancel.title": "Zrušiť konanie",
  "proceeding.actions.cancel.toast.success": "Konanie bolo úspešne zrušené.",
  "proceeding.actions.create.confirm.content": "Chcete vytvoriť nové správne konanie?",
  "proceeding.actions.end-suspension.button.text": "Ukončiť prerušenie",
  "proceeding.actions.end-suspension.text.message": "Chcete ukončiť prerušenie konania?",
  "proceeding.actions.end-suspension.title": "Ukončiť prerušenie konania",
  "proceeding.actions.end-suspension.toast.success": "Prerušenie konania bolo úspešne ukončené.",
  "proceeding.actions.first-stage-decision-making.button.text": "Prvostupňové rozhodovanie",
  "proceeding.actions.first-stage-decision-making.text.message": "Chcete presunúť konanie do prvostupňového rozhodovania?",
  "proceeding.actions.first-stage-decision-making.title": "Začať prvostupňové rozhodovanie",
  "proceeding.actions.first-stage-decision-making.toast.success": "Konanie bolo úspešne presunuté do prvostupňového rozhodovania.",
  "proceeding.actions.investigation.button.text": "Dokazovanie",
  "proceeding.actions.investigation.text.message": "Chcete presunúť konanie do dokazovania?",
  "proceeding.actions.investigation.title": "Začať dokazovanie",
  "proceeding.actions.investigation.toast.success": "Konanie bolo úspešne presunuté do dokazovania.",
  "proceeding.actions.mock-activate.button.text": "Aktivovať",
  "proceeding.actions.mock-activate.text.message": "Chcete aktivovať konanie?",
  "proceeding.actions.mock-activate.title": "Aktivovať konanie",
  "proceeding.actions.mock-activate.toast.success": "Konanie bolo úspešne aktivované.",
  "proceeding.actions.open-detail": "Detail konania",
  "proceeding.actions.second-stage-decision.button.text": "Druhostupňové rozhodnutie",
  "proceeding.actions.second-stage-decision.text.message": "Chcete presunúť konanie do druhostupňového rozhodnutia?",
  "proceeding.actions.second-stage-decision.title": "Začať druhostupňové rozhodnutie",
  "proceeding.actions.second-stage-decision.toast.success": "Konanie bolo úspešne presunuté do druhostupňového rozhodnutia.",
  "proceeding.actions.selection-required": "Vyberte aspoň jeden záznam.",
  "proceeding.actions.suspend.button.text": "Prerušiť",
  "proceeding.actions.suspend.fields.suspended-from.label": "Prerušené od",
  "proceeding.actions.suspend.fields.suspended-to.label": "Prerušené do",
  "proceeding.actions.suspend.group.title": "Prerušenie konania",
  "proceeding.actions.suspend.title": "Prerušiť konanie",
  "proceeding.actions.suspend.toast.success": "Konanie bolo úspešne prerušené.",
  "proceeding.actions.termination.button.text": "Zastaviť",
  "proceeding.actions.termination.fields.termination-reason.label": "Dôvod zastavenia konania",
  "proceeding.actions.termination.group.title": "Zastavenie konania",
  "proceeding.actions.termination.title": "Zastaviť konanie",
  "proceeding.actions.termination.toast.success": "Konanie bolo úspešne zastavené.",
  "proceeding.activity.columns.author.label": "Autor",
  "proceeding.activity.columns.event-type.label": "Typ udalosti",
  "proceeding.activity.columns.message.label": "Správa",
  "proceeding.activity.columns.timestamp.label": "Dátum a čas",
  "proceeding.activity.event.document-downloaded": "Záznam stiahnutý",
  "proceeding.activity.event.document-opened": "Záznam otvorený",
  "proceeding.activity.event.document-previewed": "Záznam zobrazený",
  "proceeding.activity.event.proceeding-opened": "Konanie otvorené",
  "proceeding.activity.title": "História prístupov",
  "proceeding.agenda.option.cross-border-care": "Cezhraničná starostlivosť",
  "proceeding.agenda.option.forced-administration": "Nútená správa",
  "proceeding.agenda.option.health-care-provided-outside-eu": "Zdravotná starostlivosť poskytnutá mimo EÚ",
  "proceeding.agenda.option.issuance-of-authorization": "Vydanie povolenia",
  "proceeding.agenda.option.other": "Iné",
  "proceeding.agenda.option.planned-health-care": "Plánovaná zdravotná starostlivosť",
  "proceeding.agenda.option.preliminary-measure": "Predbežné opatrenie",
  "proceeding.agenda.option.recovery-plan": "Ozdravný plán",
  "proceeding.agenda.option.sanction-proceeding": "Sankčné konanie",
  "proceeding.audit.fields.created-at": "Dátum vytvorenia",
  "proceeding.audit.fields.created-by": "Vytvoril",
  "proceeding.audit.fields.deleted": "Vymazaný záznam",
  "proceeding.audit.fields.id": "Identifikátor",
  "proceeding.audit.fields.modified-at": "Dátum poslednej zmeny",
  "proceeding.audit.fields.modified-by": "Naposledy upravil",
  "proceeding.base-info.group.title": "Správne konanie",
  "proceeding.batch-import.menu.label": "Importy dávok",
  "proceeding.category.option.cz": "Cezhraničná starostlivosť",
  "proceeding.category.option.mop": "Mimoriadne opravné prostriedky",
  "proceeding.category.option.pp": "Pokuta platiteľovi/poistencovi",
  "proceeding.category.option.pr": "Prerozdeľovanie poistného",
  "proceeding.category.option.ps": "Predchádzajúce súhlasy",
  "proceeding.category.option.pv": "Platobné výmery",
  "proceeding.category.option.si": "Sprístupnenie informácií",
  "proceeding.category.option.zp": "Zdravotné poistenie",
  "proceeding.category.option.zs": "Zdravotná starostlivosť",
  "proceeding.columns.category.label": "Kategória",
  "proceeding.columns.current-tasks.label": "Úlohy",
  "proceeding.columns.end-date.label": "Koniec konania",
  "proceeding.columns.matter.label": "Vec konania",
  "proceeding.columns.note.label": "Poznámka",
  "proceeding.columns.proceeding-number.label": "Číslo správneho konania",
  "proceeding.columns.processing-officer.label": "Spracovateľ",
  "proceeding.columns.start-date.label": "Začiatok konania",
  "proceeding.columns.type.label": "Typ",
  "proceeding.cz.fields.agenda.label": "Predmet konania",
  "proceeding.cz.fields.termination-reason.label": "Dôvod zastavenia konania",
  "proceeding.cz.layout-group.title": "Cezhraničná starostlivosť",
  "proceeding.deadline.evidence.table.title": "Lehoty",
  "proceeding.detail.menu.activity": "História prístupov",
  "proceeding.detail.menu.back-to-list": "Späť na zoznam",
  "proceeding.detail.menu.base-info": "Základné informácie",
  "proceeding.detail.menu.deadline": "Lehoty",
  "proceeding.detail.menu.document": "Záznamy",
  "proceeding.detail.menu.file": "Spis",
  "proceeding.detail.menu.fine": "Sankcie a pokuty",
  "proceeding.detail.menu.first-instance": "1. stupeň",
  "proceeding.detail.menu.history": "História zmien",
  "proceeding.detail.menu.participants": "Účastníci",
  "proceeding.detail.menu.related-cases": "Súvisiace konania a prípady",
  "proceeding.detail.menu.second-instance": "2. stupeň",
  "proceeding.detail.menu.task": "Úlohy",
  "proceeding.document.actions.create-document-access-log.dates.title": "Údaje o nahliadnutí",
  "proceeding.document.actions.create-document-access-log.file-accessed-at": "Dátum a čas nahliadnutia",
  "proceeding.document.actions.create-document-access-log.patient": "Účastník",
  "proceeding.document.actions.create-document-access-log.record-date": "Dátum zápisnice",
  "proceeding.document.actions.create-document-access-log.representative": "Zástupca",
  "proceeding.document.actions.create-document-access-log.request-received-date": "Dátum doručenia žiadosti",
  "proceeding.document.actions.create-document-access-log.sdzs-address": "Adresa ŠDZS",
  "proceeding.document.actions.create-document-access-log.sdzs-branch": "Pobočka ŠDZS",
  "proceeding.document.actions.create-document-access-log.sdzs.title": "ŠDZS",
  "proceeding.document.actions.create-document-access-log.subjects.title": "Subjekty konania",
  "proceeding.document.actions.create-document-access-log.success": "Zápisnica bola úspešne vytvorená.",
  "proceeding.document.actions.create-document-access-log.title": "Vytvoriť zápisnicu",
  "proceeding.document.actions.create-document-access-log.tooltip": "Vytvoriť zápisnicu",
  "proceeding.document.actions.download.confirm": "Prajete si stiahnuť vybraté záznamy?",
  "proceeding.document.actions.download.confirm.skipped": "{count} záznamov bez finalizovaného XML nebude zahrnutých.",
  "proceeding.document.actions.download.title": "Stiahnuť záznamy",
  "proceeding.document.actions.download.tooltip": "Stiahnuť záznamy",
  "proceeding.document.base-info.group.title": "Základné informácie",
  "proceeding.document.columns.context.no-proceeding": "žiadne",
  "proceeding.document.columns.context.proceeding": "Konanie: {label}",
  "proceeding.document.columns.finalized.label": "Finalizovaný",
  "proceeding.document.columns.label.label": "Popis",
  "proceeding.document.columns.registry-record-state.label": "Stav registratúrneho záznamu",
  "proceeding.document.columns.registry-record-type.label": "Typ registratúrneho záznamu",
  "proceeding.document.columns.ris-id.label": "RIS ID",
  "proceeding.document.columns.ris-number.label": "Číslo RIS",
  "proceeding.document.columns.title.label": "Názov záznamu",
  "proceeding.document.content.template-missing": "Najprv vyberte šablónu záznamu v základných informáciách.",
  "proceeding.document.deadline.duration.value": "{duration} ({lapseType})",
  "proceeding.document.deadline.sync.duration.value": "{duration} ({lapseType}), stav: {recordState}",
  "proceeding.document.deadlines.finalization.group.title": "Lehoty pri finalizácii",
  "proceeding.document.deadlines.synchronization.group.title": "Lehoty po synchronizácii",
  "proceeding.document.evidence.table.title": "Záznamy",
  "proceeding.document.fields.ais-number.label": "Číslo AIS",
  "proceeding.document.fields.description.label": "Popis záznamu",
  "proceeding.document.fields.finalized.label": "Finalizovaný",
  "proceeding.document.fields.last-synced-at.label": "Posledná úspešná synchronizácia s RIS",
  "proceeding.document.fields.note.label": "Poznámka",
  "proceeding.document.fields.registry-record-state.label": "Stav registratúrneho záznamu",
  "proceeding.document.fields.registry-record-type.label": "Typ registratúrneho záznamu",
  "proceeding.document.fields.ris-id.label": "RIS ID",
  "proceeding.document.fields.ris-number.label": "Číslo RIS",
  "proceeding.document.fields.template.label": "Šablóna záznamu",
  "proceeding.document.fields.title.label": "Názov záznamu",
  "proceeding.document.finalize.deadline.duration.label": "{title} ({lapseType}){recordState}",
  "proceeding.document.finalize.deadline.fixed-duration.value": "{duration} ({lapseType}){recordState}",
  "proceeding.document.finalize.deadlines.group.title": "Lehoty pri finalizácii",
  "proceeding.document.finalize.dialog.title": "Finalizovať záznam",
  "proceeding.document.finalize.success": "Záznam bol úspešne finalizovaný.",
  "proceeding.document.finalize.sync-deadlines.group.title": "Lehoty po synchronizácii",
  "proceeding.document.finalize.toolbar.tooltip": "Finalizovať záznam",
  "proceeding.document.form.attachments.label": "Prílohy",
  "proceeding.document.form.carbon-copy-recipients.label": "Adresáti na vedomie",
  "proceeding.document.form.main-recipients.label": "Hlavní adresáti",
  "proceeding.document.form.recipients.group.title": "Adresáti",
  "proceeding.document.form.validation.recipients.overlap": "Adresát nemôže byť zároveň hlavný adresát aj adresát na vedomie.",
  "proceeding.document.recipient-option.address-missing": "Adresát nemá vyplnené sídlo alebo trvalý pobyt.",
  "proceeding.document.tabs.base-info": "Základné informácie",
  "proceeding.document.tabs.content": "Obsah záznamu",
  "proceeding.document.wkf.request-id.label": "ID žiadosti WKF",
  "proceeding.document.wkf.state.label": "Stav WKF",
  "proceeding.evidence.menu.active": "Aktívne",
  "proceeding.evidence.menu.archived": "Archivované",
  "proceeding.evidence.menu.cancelled": "Zrušené",
  "proceeding.evidence.menu.completed": "Ukončené",
  "proceeding.evidence.menu.draft": "Koncepty",
  "proceeding.evidence.menu.suspended": "Prerušené",
  "proceeding.evidence.menu.terminated": "Zastavené",
  "proceeding.evidence.menu.title": "Správne konania",
  "proceeding.factual-basis.fields.legal-provision.label": "Ustanovenie zákona",
  "proceeding.factual-basis.fields.text.label": "Text",
  "proceeding.factual-basis.fields.violation-end.label": "Koniec porušenia",
  "proceeding.factual-basis.fields.violation-start.label": "Začiatok porušenia",
  "proceeding.factual-basis.layout-group.title": "Skutková podstata",
  "proceeding.fields.agenda.label": "Predmet konania",
  "proceeding.fields.category": "Druh konania",
  "proceeding.fields.category.label": "Druh konania",
  "proceeding.fields.department.label": "Útvar",
  "proceeding.fields.end-date": "Dátum ukončenia",
  "proceeding.fields.end-date.label": "Dátum ukončenia konania",
  "proceeding.fields.judicial-review": "Súdny prieskum",
  "proceeding.fields.judicial-review.court-file-reference": "Spisová značka súdu",
  "proceeding.fields.judicial-review.court-proceeding-end-date": "Dátum ukončenia konania na súde",
  "proceeding.fields.judicial-review.court-proceeding-start-date": "Dátum začatia konania na súde",
  "proceeding.fields.judicial-review.final-court-decision": "Právoplatný výrok súdu",
  "proceeding.fields.matter": "Vec konania",
  "proceeding.fields.matter.label": "Vec konania",
  "proceeding.fields.note": "Poznámka",
  "proceeding.fields.note.label": "Poznámka",
  "proceeding.fields.pip-control-agenda-id": "ID kontrolnej agendy PIP",
  "proceeding.fields.pip-control-agenda-type": "Typ kontrolnej agendy PIP",
  "proceeding.fields.proceeding-number": "Číslo konania",
  "proceeding.fields.proceeding-number.label": "Číslo správneho konania",
  "proceeding.fields.processing-officer": "Spracovateľ",
  "proceeding.fields.processing-officer.label": "Spracovateľ",
  "proceeding.fields.registry-file": "Spis",
  "proceeding.fields.related-cases": "Prepojené prípady",
  "proceeding.fields.stage": "Aktuálne štádium",
  "proceeding.fields.stage.label": "Aktuálne štádium konania",
  "proceeding.fields.start-date": "Začiatok konania",
  "proceeding.fields.start-date.label": "Začiatok konania",
  "proceeding.fields.state.label": "Stav konania",
  "proceeding.fields.status": "Stav",
  "proceeding.fields.status.label": "Systémový stav konania",
  "proceeding.fields.suspensions": "Prerušenia konania",
  "proceeding.fields.termination-reason.label": "Dôvod zastavenia konania",
  "proceeding.fields.type": "Typ konania",
  "proceeding.fields.type.label": "Typ konania",
  "proceeding.fine-type.evidence.table.title": "Druhy sankcií a opatrení",
  "proceeding.fine-type.menu.label": "Druhy sankcií a opatrení",
  "proceeding.fine-type.tabs.base-info": "Základné informácie",
  "proceeding.fine.cancel.amount": "Suma storna (po uložení ju nemožno meniť)",
  "proceeding.fine.cancel.success": "Storno a opravné CSV boli uložené. Odoslanie e-mailom a na SharePoint bolo simulované (mock).",
  "proceeding.fine.cancel.title": "Stornovať pokutu",
  "proceeding.fine.cancellation-email": "Odoslanie CSV storna e-mailom (OE)",
  "proceeding.fine.cancellation-sharepoint": "Odoslanie CSV storna na SharePoint",
  "proceeding.fine.cancelled-amount": "Suma storna (nemenná)",
  "proceeding.fine.cancelled-at": "Storno evidované",
  "proceeding.fine.download.cancellation-csv.2": "Stiahnuť CSV storna pre Softip",
  "proceeding.fine.download.csv.2": "Stiahnuť CSV pre Softip",
  "proceeding.fine.download.efk": "Stiahnuť výsledok eFK PDF",
  "proceeding.fine.download.pdf": "Stiahnuť hlásenie PDF",
  "proceeding.fine.download.xlsx": "Stiahnuť hlásenie XLSX",
  "proceeding.fine.efk.decided-at": "Rozhodnuté",
  "proceeding.fine.email": "Odoslanie CSV pre Softip e-mailom (OE)",
  "proceeding.fine.fields.amount.label": "Výška pokuty",
  "proceeding.fine.fields.due-date.label": "Dátum splatnosti pokuty",
  "proceeding.fine.fields.legal-force-date.label": "Dátum právoplatnosti pokuty",
  "proceeding.fine.fields.participant.label": "Účastník konania",
  "proceeding.fine.fields.reason.label": "Dôvod uloženia pokuty",
  "proceeding.fine.fields.type.label": "Druh sankcie alebo opatrenia",
  "proceeding.fine.fields.variable-symbol.label": "Variabilný symbol",
  "proceeding.fine.form-header.title": "Sankcie a pokuty",
  "proceeding.fine.generate-report.confirm.2": "Po vygenerovaní hlásenia sa údaje už nedajú meniť.",
  "proceeding.fine.generate-report.success": "Hlásenie, mock eFK a CSV boli vytvorené. Odoslanie bolo simulované.",
  "proceeding.fine.generate-report.title": "Generuj hlásenie",
  "proceeding.fine.layout-group.title": "Sankcia a pokuta",
  "proceeding.fine.reported-at": "Hlásenie vytvorené",
  "proceeding.fine.sharepoint": "Odoslanie CSV pre Softip na SharePoint",
  "proceeding.fine.wkf.group.title.2": "Elektronická finančná kontrola",
  "proceeding.fine.workflow.title": "Hlásenie, odoslanie a storno",
  "proceeding.first-stage.columns.start-date.label": "Dátum začatia konania",
  "proceeding.first-stage.columns.version.label": "Verzia",
  "proceeding.first-stage.tabs.actions": "Úkony",
  "proceeding.first-stage.tabs.base-info": "Základné informácie",
  "proceeding.first-stage.tabs.history": "História zmien",
  "proceeding.first-stage.version.title": "Verzia {version}",
  "proceeding.first-stage.versions.title": "Verzie",
  "proceeding.menu.label": "Správne konanie",
  "proceeding.mop.fields.prosecutor-submission-date.label": "Dátum predloženia prokurátorom nadriadenému orgánu",
  "proceeding.mop.fields.reopened-proceeding-referral-date.label": "Postúpenie spisu na obnovené konanie",
  "proceeding.mop.fields.resolution-method.label": "Spôsob ukončenia konania",
  "proceeding.mop.layout-group.title": "Mimoriadne opravné prostriedky",
  "proceeding.mop.resolution-method.option.decision-change-outside-appeal": "Zmena rozhodnutia mimo odvolacieho konania",
  "proceeding.mop.resolution-method.option.decision-revocation-outside-appeal": "Zrušenie rozhodnutia mimo odvolacieho konania",
  "proceeding.mop.resolution-method.option.other": "Iné",
  "proceeding.mop.resolution-method.option.proceeding-terminated": "Zastavenie konania",
  "proceeding.mop.resolution-method.option.prosecutor-protest-accepted-and-partial-revocation": "Vyhovenie protestu prokurátora a čiastočné zrušenie rozhodnutia",
  "proceeding.mop.resolution-method.option.prosecutor-protest-accepted-and-revocation": "Vyhovenie protestu prokurátora a zrušenie rozhodnutia",
  "proceeding.mop.resolution-method.option.prosecutor-protest-rejected": "Nevyhovenie protestu prokurátora",
  "proceeding.mop.resolution-method.option.renewal-authorization": "Povolenie obnovy konania",
  "proceeding.mop.resolution-method.option.renewal-authorization-and-decision": "Povolenie obnovy konania a rozhodnutie vo veci",
  "proceeding.mop.resolution-method.option.renewal-order": "Nariadenie obnovy konania",
  "proceeding.mop.resolution-method.option.renewal-order-and-decision": "Nariadenie obnovy konania a rozhodnutie vo veci",
  "proceeding.mop.resolution-method.option.renewal-rejection": "Nepovolenie obnovy konania",
  "proceeding.pip-records.columns.number": "Číslo záznamu",
  "proceeding.pip-records.columns.received": "Prijaté do RIS",
  "proceeding.pip-records.columns.title": "Názov",
  "proceeding.pip-records.columns.type": "Typ",
  "proceeding.pip-records.empty": "Spisy súvisiacich prípadov IS PIP neobsahujú žiadne záznamy alebo ešte nie sú známe.",
  "proceeding.pip-records.error": "Záznamy z IS PIP sa nepodarilo načítať.",
  "proceeding.pip-records.loading": "Načítavam záznamy z IS PIP…",
  "proceeding.pip-records.open-ris": "Otvoriť v RIS",
  "proceeding.pip-records.title": "Podklady z PIP",
  "proceeding.pip-records.truncated": "Zobrazených prvých {shown} z {total} záznamov.",
  "proceeding.policy.reason.default": "Akcia nie je dostupná.",
  "proceeding.policy.reason.invalid-status": "Akcia nie je dostupná v aktuálnom stave konania.",
  "proceeding.policy.reason.missing-permission": "Nemáte oprávnenie na vykonanie akcie.",
  "proceeding.policy.reason.not-processing-officer": "Nie ste spracovateľom konania.",
  "proceeding.policy.reason.note-only-field": "V tomto stave je možné upraviť iba poznámku.",
  "proceeding.policy.reason.readonly-field": "Pole nie je editovateľné.",
  "proceeding.pp.fields.agenda.label": "Predmet konania",
  "proceeding.pp.fields.state.label": "Stav konania",
  "proceeding.pp.fields.termination-reason.label": "Dôvod zastavenia konania",
  "proceeding.pp.fields.violation-from-date.label": "Dátum začiatku porušenia",
  "proceeding.pp.fields.violation-to-date.label": "Dátum konca porušenia",
  "proceeding.pp.layout-group.title": "Pokuta platiteľovi/poistencovi",
  "proceeding.pr.fields.claim-amounts.label": "Výšky pohľadávky alebo záväzku pre subjekt",
  "proceeding.pr.fields.decision-enforceability-by-subject-dates.label": "Dátum vykonateľnosti rozhodnutia pre subjekt",
  "proceeding.pr.fields.decision-legal-force-by-subject-dates.label": "Dátum právoplatnosti rozhodnutia pre subjekt",
  "proceeding.pr.fields.notification-infos.label": "Informácie o oznámení k prerozdeľovaniu",
  "proceeding.pr.fields.state.label": "Stav konania",
  "proceeding.pr.layout-group.title": "Prerozdeľovanie poistného",
  "proceeding.ps.fields.state.label": "Stav konania",
  "proceeding.ps.fields.termination-reason.label": "Dôvod zastavenia konania",
  "proceeding.ps.layout-group.title": "Predchádzajúce súhlasy",
  "proceeding.pv.arrears.fields.paid-rzzp-amount.label": "Úhrada nedoplatku RZZP",
  "proceeding.pv.arrears.fields.payment-date.label": "Dátum úhrady",
  "proceeding.pv.arrears.fields.report-issue-date.label": "Dátum vydania výkazu nedoplatkov",
  "proceeding.pv.arrears.fields.report-number.label": "Číslo výkazu nedoplatkov",
  "proceeding.pv.arrears.fields.rzzp-amount.label": "Výsledok RZZP / výška nedoplatku",
  "proceeding.pv.arrears.fields.rzzp-report-number.label": "Číslo výkazu nedoplatkov RZZP",
  "proceeding.pv.arrears.fields.total-amount.label": "Suma poplatku za VN (výkaz nedoplatkov)",
  "proceeding.pv.arrears.fields.total-unpaid-amount.label": "Celková neuhradená suma",
  "proceeding.pv.arrears.layout-group.title": "Nedoplatky",
  "proceeding.pv.claim-origin-periods.add": "Pridať obdobie",
  "proceeding.pv.claim-origin-periods.empty": "Nie sú evidované žiadne obdobia.",
  "proceeding.pv.claim-origin-periods.remove": "Odstrániť obdobie",
  "proceeding.pv.costs.fields.bank-account-number.label": "Číslo bankového účtu",
  "proceeding.pv.costs.fields.bank-code.label": "Kód banky",
  "proceeding.pv.costs.fields.constant-symbol.label": "Konštantný symbol",
  "proceeding.pv.costs.fields.variable-symbol.label": "Variabilný symbol",
  "proceeding.pv.costs.layout-group.title": "Trovy",
  "proceeding.pv.fields.annual-settlement-period-from.label": "Obdobie RZ (ročné zúčtovanie) od",
  "proceeding.pv.fields.annual-settlement-period-to.label": "Obdobie RZ (ročné zúčtovanie) do",
  "proceeding.pv.fields.claim-origin-period-from.label": "Obdobie vzniku pohľadávky od",
  "proceeding.pv.fields.claim-origin-period-to.label": "Obdobie vzniku pohľadávky do",
  "proceeding.pv.fields.claim-origin-periods.label": "Obdobie vzniku pohľadávky",
  "proceeding.pv.fields.late-payment-interest.label": "Úrok z omeškania",
  "proceeding.pv.fields.principal-amount.label": "Istina",
  "proceeding.pv.fields.state.label": "Stav konania",
  "proceeding.pv.fields.total-claim-amount.label": "Celková suma pohľadávky",
  "proceeding.pv.fields.vzp-proposal-type.label": "Druh návrhu VZP",
  "proceeding.pv.fields.zp-proposal-type.label": "Druh návrhu ZP",
  "proceeding.pv.layout-group.title": "Platobné výmery",
  "proceeding.pv.vzp-proposal-type.option.i": "I",
  "proceeding.pv.vzp-proposal-type.option.k": "K",
  "proceeding.pv.vzp-proposal-type.option.u": "U",
  "proceeding.pv.zp-proposal-type.option.i": "I",
  "proceeding.pv.zp-proposal-type.option.k": "K",
  "proceeding.pv.zp-proposal-type.option.p": "P",
  "proceeding.pv.zp.fields.account-number.label": "Číslo bankového účtu ZP",
  "proceeding.pv.zp.fields.constant-symbol.label": "Konštantný symbol ZP",
  "proceeding.pv.zp.fields.overpayment-variable-symbol.label": "Variabilný symbol ZP pre úrok",
  "proceeding.pv.zp.fields.specific-symbol.label": "Špecifický symbol ZP",
  "proceeding.pv.zp.fields.variable-symbol.label": "Variabilný symbol ZP",
  "proceeding.pv.zp.layout-group.title": "Údaje ZP",
  "proceeding.second-committee-outcome.evidence.table.title": "Výsledky rokovania komisie",
  "proceeding.second-committee-outcome.menu.label": "Výsledky rokovania komisie",
  "proceeding.second-committee-outcome.tabs.base-info": "Základné informácie",
  "proceeding.second-decision-outcome.evidence.table.title": "Výroky druhostupňového rozhodnutia",
  "proceeding.second-decision-outcome.menu.label": "Výroky druhostupňového rozhodnutia",
  "proceeding.second-decision-outcome.tabs.base-info": "Základné informácie",
  "proceeding.second-stage.columns.case-received-date.label": "Dátum doručenia spisu",
  "proceeding.second-stage.columns.version.label": "Verzia",
  "proceeding.second-stage.tabs.actions": "Úkony",
  "proceeding.second-stage.tabs.base-info": "Základné informácie",
  "proceeding.second-stage.tabs.history": "História zmien",
  "proceeding.second-stage.version.title": "Verzia {version}",
  "proceeding.second-stage.versions.title": "Verzie",
  "proceeding.si.access-method.option.elektronickou-schrankou": "Elektronickou schránkou",
  "proceeding.si.access-method.option.emailom": "E-mailom",
  "proceeding.si.access-method.option.ine": "Iné",
  "proceeding.si.access-method.option.nahliadnutim": "Nahliadnutím",
  "proceeding.si.access-method.option.postou": "Poštou",
  "proceeding.si.access-method.option.ustne-alebo-telefonicky": "Ústne alebo telefonicky",
  "proceeding.si.fields.proposed-access-method.label": "Navrhovaný spôsob sprístupnenia",
  "proceeding.si.fields.request-number.label": "Evidenčné číslo žiadosti",
  "proceeding.si.fields.request-received-date.label": "Dátum doručenia žiadosti",
  "proceeding.si.fields.request-subject.label": "Predmet žiadosti",
  "proceeding.si.fields.request-submission-method.label": "Spôsob podania žiadosti",
  "proceeding.si.fields.requested-access-method.label": "Požadovaný spôsob sprístupnenia",
  "proceeding.si.fields.requested-information.label": "Vyžiadaná informácia",
  "proceeding.si.fields.resolution-methods.label": "Spôsoby vybavenia",
  "proceeding.si.layout-group.title": "Sprístupnenie informácií",
  "proceeding.si.request-submission-method.option.emailom": "Emailom",
  "proceeding.si.request-submission-method.option.faxom": "Faxom",
  "proceeding.si.request-submission-method.option.iny": "Iný",
  "proceeding.si.request-submission-method.option.pisomne": "Písomne",
  "proceeding.si.request-submission-method.option.upvs": "UPVS",
  "proceeding.si.request-submission-method.option.ustne": "Ústne",
  "proceeding.si.resolution-method.option.odkaz-na-zverejnenu-informaciu": "Odkaz na zverejnenú informáciu",
  "proceeding.si.resolution-method.option.odlozenie-ziadosti": "Odloženie žiadosti",
  "proceeding.si.resolution-method.option.poskytnutie-informacii": "Poskytnutie informácií",
  "proceeding.si.resolution-method.option.postupenie-ziadosti": "Postúpenie žiadosti",
  "proceeding.si.resolution-method.option.vydanie-rozhodnutia": "Vydanie rozhodnutia",
  "proceeding.sidebar.info.pip-cases": "Prípady IS PIP",
  "proceeding.sidebar.info.status": "Stav",
  "proceeding.sidebar.info.title": "Prehľad",
  "proceeding.stage.date-time-rows.add": "Pridať záznam",
  "proceeding.stage.date-time-rows.date.label": "Dátum",
  "proceeding.stage.date-time-rows.empty": "Nie sú evidované žiadne záznamy.",
  "proceeding.stage.first.actions.appeal-delivery-dates.label": "Doručenie odvolania",
  "proceeding.stage.first.actions.appeal-submission-dates.label": "Podanie odvolania",
  "proceeding.stage.first.actions.autoremedure-delivery-dates.label": "Doručenie rozhodnutia v autoremedúre",
  "proceeding.stage.first.actions.autoremedure-issuance-dates.label": "Vydanie rozhodnutia v autoremedúre",
  "proceeding.stage.first.actions.autoremedure-sending-dates.label": "Odoslanie rozhodnutia v autoremedúre",
  "proceeding.stage.first.actions.cooperation-request-delivery-dates.label": "Doručenie žiadosti o súčinnosť",
  "proceeding.stage.first.actions.create-version.button.text": "Nová verzia",
  "proceeding.stage.first.actions.create-version.confirm.content": "Chcete vytvoriť novú verziu prvého stupňa?",
  "proceeding.stage.first.actions.create-version.toast.success": "Nová verzia bola úspešne vytvorená.",
  "proceeding.stage.first.actions.decision-delivery-dates.label": "Doručenie prvostupňového rozhodnutia",
  "proceeding.stage.first.actions.decision-enforceability-dates.label": "Dátum vykonateľnosti rozhodnutia",
  "proceeding.stage.first.actions.decision-legal-force-dates.label": "Dátum právoplatnosti prvostupňového rozhodnutia",
  "proceeding.stage.first.actions.notice-deadline-expiration-dates.label": "Uplynutie lehoty vo výzve",
  "proceeding.stage.first.actions.notice-delivery-dates.label": "Doručenie výzvy",
  "proceeding.stage.first.audit.fields.created-at": "Dátum vytvorenia",
  "proceeding.stage.first.audit.fields.created-by": "Vytvoril",
  "proceeding.stage.first.audit.fields.deleted": "Vymazaný záznam",
  "proceeding.stage.first.audit.fields.id": "Identifikátor",
  "proceeding.stage.first.audit.fields.modified-at": "Dátum poslednej zmeny",
  "proceeding.stage.first.audit.fields.modified-by": "Naposledy upravil",
  "proceeding.stage.first.base-info.group.title": "Základné údaje prvostupňového konania",
  "proceeding.stage.first.fields.cooperation-request-deadline.label": "Uplynutie lehoty v žiadosti o súčinnosť",
  "proceeding.stage.first.fields.decision-issued.label": "Vydanie prvostupňového rozhodnutia",
  "proceeding.stage.first.fields.decision-outcome.label": "Výrok rozhodnutia",
  "proceeding.stage.first.fields.decision-sent.label": "Odoslanie prvostupňového rozhodnutia",
  "proceeding.stage.first.fields.forwarded-to-second-instance.label": "Postúpenie spisu druhému stupňu",
  "proceeding.stage.first.fields.note.label": "Poznámka",
  "proceeding.stage.first.fields.proceeding.label": "Správne konanie",
  "proceeding.stage.first.fields.start-date.label": "Dátum začatia konania",
  "proceeding.stage.first.fields.version.label": "Verzia",
  "proceeding.stage.option.first-instance": "Prvostupňové konanie",
  "proceeding.stage.option.second-instance": "Druhostupňové konanie",
  "proceeding.stage.second.actions.cooperation-request-deadline-expiration-dates.label": "Uplynutie lehoty v žiadosti o súčinnosť",
  "proceeding.stage.second.actions.cooperation-request-delivery-dates.label": "Doručenie žiadosti o súčinnosť",
  "proceeding.stage.second.actions.create-version.button.text": "Nová verzia",
  "proceeding.stage.second.actions.create-version.confirm.content": "Chcete vytvoriť novú verziu druhého stupňa?",
  "proceeding.stage.second.actions.create-version.toast.success": "Nová verzia bola úspešne vytvorená.",
  "proceeding.stage.second.actions.decision-delivery-dates.label": "Doručenie druhostupňového rozhodnutia",
  "proceeding.stage.second.actions.notice-delivery-dates.label": "Doručenie výzvy",
  "proceeding.stage.second.audit.fields.created-at": "Dátum vytvorenia",
  "proceeding.stage.second.audit.fields.created-by": "Vytvoril",
  "proceeding.stage.second.audit.fields.deleted": "Vymazaný záznam",
  "proceeding.stage.second.audit.fields.id": "Identifikátor",
  "proceeding.stage.second.audit.fields.modified-at": "Dátum poslednej zmeny",
  "proceeding.stage.second.audit.fields.modified-by": "Naposledy upravil",
  "proceeding.stage.second.base-info.group.title": "Základné údaje druhostupňového konania",
  "proceeding.stage.second.fields.case-received-date.label": "Dátum doručenia spisu",
  "proceeding.stage.second.fields.case-returned.label": "Vrátenie spisu",
  "proceeding.stage.second.fields.committee-session-outcome.label": "Výsledok rokovania komisie",
  "proceeding.stage.second.fields.committee-sessions.label": "Zasadnutia komisie",
  "proceeding.stage.second.fields.decision-issued.label": "Vydanie druhostupňového rozhodnutia",
  "proceeding.stage.second.fields.decision-outcome.label": "Výrok rozhodnutia",
  "proceeding.stage.second.fields.decision-sent.label": "Odoslanie druhostupňového rozhodnutia",
  "proceeding.stage.second.fields.enforceability.label": "Vykonateľnosť druhostupňového rozhodnutia",
  "proceeding.stage.second.fields.late-appeal-statement.label": "Vyjadrenie k oneskorenému odvolaniu",
  "proceeding.stage.second.fields.legal-force.label": "Právoplatnosť druhostupňového rozhodnutia",
  "proceeding.stage.second.fields.note.label": "Poznámka",
  "proceeding.stage.second.fields.notice-deadline.label": "Dátum uplynutia lehoty vo výzve",
  "proceeding.stage.second.fields.proceeding.label": "Správne konanie",
  "proceeding.stage.second.fields.version.label": "Verzia",
  "proceeding.state.option.appeal-first-stage": "Odvolacie konanie - prvý stupeň",
  "proceeding.state.option.appeal-second-stage": "Odvolacie konanie - druhý stupeň",
  "proceeding.state.option.decision": "Rozhodovanie",
  "proceeding.state.option.evidence": "Evidencia konania",
  "proceeding.state.option.finished": "Ukončené",
  "proceeding.state.option.first-stage-decision-making": "Prvostupňové rozhodovanie",
  "proceeding.state.option.first-stage-proceeding": "Prvostupňové konanie",
  "proceeding.state.option.investigation": "Dokazovanie",
  "proceeding.state.option.legally-finished": "Právoplatne ukončené",
  "proceeding.state.option.not-started": "Nezačaté",
  "proceeding.state.option.sanction-proceeding": "Sankčné konanie",
  "proceeding.state.option.second-stage-decision": "Druhostupňové rozhodnutie",
  "proceeding.state.option.second-stage-investigation": "Druhostupňové dokazovanie",
  "proceeding.state.option.suspended": "Prerušené",
  "proceeding.state.option.terminated": "Zastavené",
  "proceeding.status.option.active": "Aktívne",
  "proceeding.status.option.archived": "Archivované",
  "proceeding.status.option.cancelled": "Zrušené",
  "proceeding.status.option.completed": "Ukončené",
  "proceeding.status.option.draft": "Koncept",
  "proceeding.status.option.suspended": "Prerušené",
  "proceeding.status.option.terminated": "Zastavené",
  "proceeding.subject-action-date.add": "Pridať záznam",
  "proceeding.subject-action-date.empty": "Nie sú evidované žiadne záznamy.",
  "proceeding.subject.audit.fields.created-at": "Dátum vytvorenia",
  "proceeding.subject.audit.fields.created-by": "Vytvoril",
  "proceeding.subject.audit.fields.deleted": "Vymazaný záznam",
  "proceeding.subject.audit.fields.id": "Identifikátor",
  "proceeding.subject.audit.fields.modified-at": "Dátum poslednej zmeny",
  "proceeding.subject.audit.fields.modified-by": "Naposledy upravil",
  "proceeding.subject.columns.relation.label": "Vzťah subjektu ku konaniu",
  "proceeding.subject.columns.subject.label": "Subjekt",
  "proceeding.subject.evidence.table.title": "Účastníci",
  "proceeding.subject.fields.proceeding.label": "Správne konanie",
  "proceeding.subject.fields.relation.label": "Vzťah subjektu ku konaniu",
  "proceeding.subject.fields.subject.label": "Subjekt",
  "proceeding.subject.relation.option.legal-representative": "Právny zástupca",
  "proceeding.subject.relation.option.participant": "Účastník konania",
  "proceeding.subject.relation.option.prosecutor": "Prokurátor",
  "proceeding.subject.relation.option.third-person": "Tretia osoba",
  "proceeding.subject.tabs.base-info": "Základné informácie",
  "proceeding.subject.tabs.history": "História zmien",
  "proceeding.task.evidence.table.title": "Úlohy",
  "proceeding.termination-reason.evidence.table.title": "Dôvody zastavenia konania",
  "proceeding.termination-reason.fields.compatible-categories.label": "Kompatibilné druhy konania",
  "proceeding.termination-reason.menu.label": "Dôvody zastavenia konania",
  "proceeding.termination-reason.tabs.base-info": "Základné informácie",
  "proceeding.title.active": "Aktívne konania",
  "proceeding.title.all": "Všetky konania",
  "proceeding.title.archived": "Archivované konania",
  "proceeding.title.cancelled": "Zrušené konania",
  "proceeding.title.completed": "Ukončené konania",
  "proceeding.title.draft": "Koncepty konaní",
  "proceeding.title.suspended": "Prerušené konania",
  "proceeding.title.terminated": "Zastavené konania",
  "proceeding.type.option.do": "Pokuta poskytovateľovi ZZS podľa zákona 578/2004",
  "proceeding.type.option.ho": "Sankcia – hospodárenie zdravotnej poisťovne",
  "proceeding.type.option.ma": "Marenie dohľadu",
  "proceeding.type.option.mk": "Mimo odvolacieho konania",
  "proceeding.type.option.no": "Sankcia – neprijatie nápravných opatrení",
  "proceeding.type.option.nz": "Sankcia – nákup zdravotnej starostlivosti",
  "proceeding.type.option.ok": "Obnova konania",
  "proceeding.type.option.pk": "Protest prokurátora",
  "proceeding.type.option.pm": "Prehliadka mŕtveho",
  "proceeding.type.option.sd": "Poskytovanie zdravotnej starostlivosti a vedenie zdravotnej dokumentácie",
  "proceeding.type.option.su": "Neposkytnutie súčinnosti v procese výkonu dohľadu",
  "proceeding.type.option.za": "Povolenie na prevádzkovanie ambulancie ZZS",
  "proceeding.type.option.zd": "Nesprávne vedenie zdravotnej dokumentácie",
  "proceeding.type.option.zp": "Sankcia – proces verejného zdravotného poistenia",
  "proceeding.type.option.zs": "Poskytovanie zdravotnej starostlivosti",
  "proceeding.zp.fields.agenda.label": "Predmet konania",
  "proceeding.zp.fields.state.label": "Stav konania",
  "proceeding.zp.fields.termination-reason.label": "Dôvod zastavenia konania",
  "proceeding.zp.layout-group.title": "Zdravotné poistenie",
  "proceeding.zs.fields.agenda.label": "Predmet konania",
  "proceeding.zs.fields.state.label": "Stav konania",
  "proceeding.zs.fields.termination-reason.label": "Dôvod zastavenia konania",
  "proceeding.zs.layout-group.title": "Zdravotná starostlivosť",

  "region.menu.title": "Kraje",

  "registry-file.menu.title": "Spisy",
  "registry-file.proceeding.create": "Vytvoriť správne konanie",
  "registry-file.proceeding.create.title": "Nové konanie zo spisu {file}",

  "registry-record.evidence.table.title": "Záznamy",
  "registry-record.menu.title": "Záznamy",

  "restMessage.menu.title": "REST komunikácia",

  "role.menu.title": "Roly",

  "schedule.job.menu.title": "Úlohy",
  "schedule.run.menu.title": "Záznam",

  "settings.menu.title": "Používateľské nastavenia",
  "settings.profile.menu.title": "Môj profil",

  "sidebar.close.subtitle": "SK",
  "sidebar.open-menu.label": "Otvoriť menu",
  "sidebar.open.subtitle": "Správne konania",
  "sidebar.primary-items.administration": "Administrácia",
  "sidebar.primary-items.home": "Domov",

  "soapMessage.menu.title": "SOAP komunikácia",

  "subject.menu.label": "Subjekty",

  "task-type.columns.code.label": "Kód",
  "task-type.columns.color.label": "Farba",
  "task-type.columns.description.label": "Popis",
  "task-type.columns.title.label": "Názov",
  "task-type.evidence.table.title": "Typy úloh",
  "task-type.fields.code.label": "Kód",
  "task-type.fields.color.label": "Farba",
  "task-type.fields.description.label": "Popis",
  "task-type.fields.end-condition.label": "Podmienka zániku",
  "task-type.fields.start-condition.label": "Podmienka vzniku",
  "task-type.fields.title.label": "Názov",
  "task-type.menu.label": "Typy úloh",
  "task-type.tabs.base-info.label": "Základné informácie",

  "task.actions.complete.confirm.content": "Naozaj chcete označiť úlohu ako vyriešenú?",
  "task.actions.complete.toast.success.text": "Úloha bola označená ako vyriešená.",
  "task.actions.complete.toolbar.tooltip": "Vyriešiť úlohu",
  "task.actions.mock-create-proceeding-task.button.text": "Testovací úloha",
  "task.actions.mock-create-proceeding-task.confirm.content": "Chcete vytvoriť testovaciu úlohu pre konanie?",
  "task.actions.mock-create-proceeding-task.title": "Vytvoriť testovaciu úlohu",
  "task.actions.mock-create-proceeding-task.toast.success": "Testovacia úloha bola úspešne vytvorená.",
  "task.columns.assignees.label": "Riešitelia",
  "task.columns.completed-at.label": "Ukončené dňa",
  "task.columns.completed.label": "Ukončené",
  "task.columns.description.label": "Popis",
  "task.columns.type.label": "Typ",
  "task.evidence.table.title": "Úlohy",
  "task.fields.assignees.label": "Riešitelia",
  "task.fields.completed-at.label": "Ukončené dňa",
  "task.fields.completed-by.label": "Ukončil",
  "task.fields.completed.label": "Ukončené",
  "task.fields.description.label": "Popis",
  "task.fields.type.label": "Typ",
  "task.menu.label": "Úlohy",
  "task.open-fine": "Prejsť na Sankcie a pokuty",
  "task.tabs.base-info.label": "Základné informácie",

  "test-scenario.catalog.missing": "Postup nie je v exporte",
  "test-scenario.catalog.missing-count": "Bez zdrojového postupu: {count} TC.",
  "test-scenario.catalog.preparation": "Príprava: {preparation}",
  "test-scenario.catalog.role": "Rola: {roles}",
  "test-scenario.catalog.summary": "UC/TC: {tcCount} | E2E: {e2eCount}. Lokálna príprava vytvára iba predpoklady, nie kroky scenára.",
  "test-scenario.coverage.e2e": "E2E",
  "test-scenario.detail.action": "Akcia",
  "test-scenario.detail.back": "Späť na zoznam",
  "test-scenario.detail.expected": "Očakávaný výsledok",
  "test-scenario.detail.fixtures": "Pripravené záznamy",
  "test-scenario.detail.missing": "Testovací prípad nemá zdrojové inštrukcie.",
  "test-scenario.detail.no-steps": "Zdroj neobsahuje žiadne kroky.",
  "test-scenario.detail.notes": "Príprava ({preparation}) a upozornenia",
  "test-scenario.detail.preconditions": "Predpoklady",
  "test-scenario.detail.preparing": "Pripravujú sa nové lokálne dáta…",
  "test-scenario.detail.retry": "Znova pripraviť nové dáta",
  "test-scenario.detail.role": "Požadovaná rola",
  "test-scenario.detail.steps": "Kroky",
  "test-scenario.e2e.coverage": "Zdrojová procesná cesta, nie exportovaný E2E postup. Referencie bez postupu: {absent}; na kontrolu: {review}; neaktuálne: {obsolete}. Príprava všetkých predpokladov je externá; dáta sa nevytvárajú.",
  "test-scenario.e2e.unresolved": "Externá alebo neurčená referencia. Zdrojový TC postup nie je k dispozícii.",
  "test-scenario.fixture.user.first-name": "Meno",
  "test-scenario.fixture.user.last-name": "Priezvisko",
  "test-scenario.fixture.user.username": "Používateľské meno",
  "test-scenario.no-prerequisites": "Scenár {code} nevyžaduje prípravu dát.",
  "test-scenario.panel.minimize": "Minimalizovať",
  "test-scenario.panel.move": "Panel presuniete potiahnutím hlavičky.",
  "test-scenario.panel.restore": "Obnoviť",
  "test-scenario.panel.title": "Testovacie scenáre",
  "test-scenario.pp-files.failed": "Referenčná sada nebola prijatá. Overte formát, referencie a oprávnenia.",
  "test-scenario.pp-files.instructions": "Manuálny TXT podvariant: je potrebné vybrať potvrdenú referenčnú dávku PP 523/524/538/539 v ISO-8859-2 s dvomi odlišnými platnými a dosiaľ neimportovanými záznamami. Z nej sa pripravia zmiešaný a opravený TXT. Import sa nespustí.",
  "test-scenario.pp-files.invalid": "Nie je možné pripraviť balík. Vyberte TXT v ISO-8859-2, najviac 64 KiB, s hlavičkou a dvomi potvrdenými platnými riadkami.",
  "test-scenario.pp-files.prepare": "Pripraviť a stiahnuť testovacie súbory",
  "test-scenario.pp-files.result": "Referencie pripravených súborov a zostávajúce predpoklady",
  "test-scenario.pp-files.source": "Potvrdený referenčný TXT (najviac 64 KiB)",
  "test-scenario.preparation.external": "externá – dáta si pripravte sami",
  "test-scenario.preparation.local": "lokálna",
  "test-scenario.preparation.none": "nie je potrebná",
  "test-scenario.prepare": "Začať scenár",
  "test-scenario.prepare-error": "Príprava nebola potvrdená. Pred opakovaním overte, či sada už vznikla.",
  "test-scenario.prepare-label": "Začať scenár {code}",
  "test-scenario.prepared": "Scenár {code}: lokálne pripravené záznamy {count}.",
  "test-scenario.ris-file.label": "Číslo spisu v RIS",
  "test-scenario.ris-file.optional-hint": "Voliteľné. Zadajte nový prázdny spis v RIS pridelený vášmu účtu, ktorý ešte nie je evidovaný v SK. Bez čísla sa pripraví nové konanie bez RIS spisu.",
  "test-scenario.ris-file.required-hint": "Povinné. Zadajte nový prázdny spis v RIS pridelený vášmu účtu, ktorý ešte nie je evidovaný v SK.",
  "test-scenario.started": "Scenár {code} bol otvorený.",

  "tools.menu.title": "Nástroje",

  "upvs-form.menu.title": "UPVS formuláre",

  "user.menu.title": "Používatelia",

  "validation/array.exact": "Požadovaný počet položiek je {value}",
  "validation/array.too_big.exclusive": "Musí obsahovať menej ako {value, plural, =1 {jednu položku} few {# položky} other {# položiek}}",
  "validation/array.too_big.inclusive": "Musí obsahovať najviac {value, plural, =1 {jednu položku} few {# položky} other {# položiek}}",
  "validation/array.too_small.exclusive": "Musí obsahovať viac ako {value, plural, =1 {jednu položku} few {# položky} other {# položiek}}",
  "validation/array.too_small.inclusive": "Musí obsahovať aspoň {value, plural, =1 {jednu položku} few {# položky} other {# položiek}}",
  "validation/date.exact": "Musí sa zhodovať s dátumom {value}",
  "validation/date.invalid_date": "Neplatný dátum",
  "validation/date.too_big.exclusive": "Musí byť pred {value}",
  "validation/date.too_big.inclusive": "Musí byť najneskôr {value}",
  "validation/date.too_small.exclusive": "Musí byť po {value}",
  "validation/date.too_small.inclusive": "Musí byť najskôr {value}",
  "validation/default": "Neplatný vstup",
  "validation/file.required": "Povinné pole",
  "validation/number.exact": "Musí sa rovnať hodnote {value}",
  "validation/number.not_multiple_of": "Musí byť násobkom čísla {value}",
  "validation/number.too_big.exclusive": "Musí byť menšie ako {value}",
  "validation/number.too_big.inclusive": "Musí byť najviac {value}",
  "validation/number.too_small.exclusive": "Musí byť väčšie ako {value}",
  "validation/number.too_small.inclusive": "Musí byť aspoň {value}",
  "validation/string.exact": "Požadovaný počet znakov je {value}",
  "validation/string.invalid.datetime": "Neplatný dátum a čas",
  "validation/string.invalid.email": "Neplatný e-mail",
  "validation/string.invalid.endsWith": "Musí sa končiť na {value}",
  "validation/string.invalid.regex": "Neplatný formát",
  "validation/string.invalid.startsWith": "Musí sa začínať na {value}",
  "validation/string.invalid.url": "Neplatná URL adresa",
  "validation/string.required": "Povinné pole",
  "validation/string.too_big.exclusive": "Musí obsahovať menej ako {value, plural, =1 {jeden znak} few {# znaky} other {# znakov}}",
  "validation/string.too_big.inclusive": "Musí obsahovať najviac {value, plural, =1 {jeden znak} few {# znaky} other {# znakov}}",
  "validation/string.too_small.exclusive": "Musí obsahovať viac ako {value, plural, =1 {jeden znak} few {# znaky} other {# znakov}}",
  "validation/string.too_small.inclusive": "Musí obsahovať aspoň {value, plural, =1 {jeden znak} few {# znaky} other {# znakov}}",
  "validation/type.invalid": "Neplatný typ. Očakáva sa \"{expected}\", prijatá hodnota je \"{received}\"",
  "validation/type.required": "Povinné pole"
}
